import Loading from '@/components/Loading'
import SaveButton from '@/components/SaveButton'
import ExternalLink from '@/components/ExternalLink'
import Alert from '@/components/Alert'
import Heading from '@/components/Heading'

const GlobalComponents = {
  install (Vue) {
    Vue.component('Loading', Loading)
    Vue.component('Alert', Alert)
    Vue.component('SaveButton', SaveButton)
    Vue.component('ExternalLink', ExternalLink)
    Vue.component('Heading', Heading)
  }
}

export default GlobalComponents
